import React from "react";
import SectionHeader from "./SectionHeader";

const PartnersSection = ({ data }) => (
    <section className="partnerships" id="partnerships">

        <div className="container">

            {/* =================================================
                 HEADER
            ================================================== */}

            <SectionHeader
                eyebrow={data.eyebrow}
                title={data.title}
                highlight={data.highlight}
                description={data.description}
            />


            {/* =================================================
                 PARTNERS
            ================================================== */}

            <div className="partner-grid">

                {(data.items || []).map((item, i) => (

                    <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="partner-card"
                        key={i}
                    >

                        <div className="partner-logo">

                            {item.logo && (
                                <img
                                    src={item.logo}
                                    alt={item.alt || item.name}
                                />
                            )}

                        </div>

                        <h3>
                            {item.name}
                        </h3>

                    </a>

                ))}

            </div>

        </div>

    </section>
);

export default PartnersSection;